'use strict';

var _regeneratorRuntime = require("/builds/bright-technologies/inocrowd/inocrowd-web-platform/frontend/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/builds/bright-technologies/inocrowd/inocrowd-web-platform/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/bright-technologies/inocrowd/inocrowd-web-platform/frontend/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

var AuthInterceptor =
/*#__PURE__*/
function () {
  function AuthInterceptor(_ref) {
    var authService = _ref.authService;

    _classCallCheck(this, AuthInterceptor);

    this._auth = authService;
    this._tokenIsRefreshing = false;

    this._intercept();
  }

  _createClass(AuthInterceptor, [{
    key: "_intercept",
    value: function _intercept() {
      var _this2 = this;

      // Add a request interceptor
      _axios2.default.interceptors.request.use(function (config) {
        // Do something before request is sent
        var accessToken = _this2._auth.getAccessToken();

        if (accessToken && !_this2._tokenIsRefreshing) {
          config.headers.Authorization = 'Bearer ' + accessToken;
        }

        return config;
      }, function (error) {
        // Do something with request error
        return Promise.reject(error);
      }); // Add a response interceptor


      _axios2.default.interceptors.response.use(function (response) {
        // Do something with response data
        return response;
      }, function (error) {
        // Do something with response error
        var accessToken = _this2._auth.getAccessToken();

        if (accessToken && error.response.status === 401 && !error.config._isRetryRequest && error.config.url !== "".concat(_this2._auth._apiUrl, "/api/login")) {
          return _this2._refreshToken(error);
        } else {
          return Promise.reject(error);
        }
      });
    }
  }, {
    key: "_refreshToken",
    value: function _refreshToken(request) {
      var _this3 = this;

      if (this._tokenIsRefreshing) {
        // wait for the token refresh
        return this._waitForTokenRefresh().then(function () {
          request.config.headers.Authorization = 'Bearer ' + _this3._auth.getAccessToken();
          request.config._isRetryRequest = true;
          return Promise.resolve((0, _axios2.default)(request.config));
        });
      } else {
        this._tokenIsRefreshing = true;
        return this._auth.refreshToken().then(function (response) {
          _this3._tokenIsRefreshing = false;
          request.config.headers.Authorization = 'Bearer ' + _this3._auth.getAccessToken();
          return Promise.resolve((0, _axios2.default)(request.config));
        }).catch(function (error) {
          _this3._tokenIsRefreshing = false;
          return Promise.reject(error);
        });
      }
    }
  }, {
    key: "_waitForTokenRefresh",
    value: function _waitForTokenRefresh() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve) {
                  var interval = setInterval(function () {
                    if (!_this._tokenIsRefreshing) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }))();
    }
  }]);

  return AuthInterceptor;
}();

exports.default = AuthInterceptor;